document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('main-search-input');
  const suggestionPanel = document.getElementById('main-search-predictive');
  const suggestionList = document.getElementById('main-search-suggestions-list');
  let debounceTimer = null;
  let abortController = null;

  if (!searchInput || !suggestionPanel || !suggestionList) return;

  function showSuggestions() {
    suggestionPanel.style.display = 'block';
  }

  function hideSuggestions() {
    suggestionPanel.style.display = 'none';
    suggestionList.innerHTML = '';
  }

  function renderSuggestions(queryLinks) {
    if (!queryLinks.length) {
      suggestionList.innerHTML = '<p class="custom-search-no-results">No suggestions</p>';
      showSuggestions();
      return;
    }

    suggestionList.innerHTML = Array.from(queryLinks)
      .map((link) => {
        const href = link.getAttribute('href') || '#';
        const text = link.textContent.trim();
        return `<a href="${href}" class="custom-search-suggestion-link">${text}</a>`;
      })
      .join('');

    showSuggestions();
  }

  function fetchPredictiveResults(query) {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();

    const url = `${theme.routes.predictive_search_url}?q=${encodeURIComponent(query)}&${encodeURIComponent('resources[type]')}=query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`;

    fetch(url, { signal: abortController.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const section = html.querySelector('#shopify-section-predictive-search');
        if (!section) {
          hideSuggestions();
          return;
        }

        const queryLinks = section.querySelectorAll('.thb-predictive-search--popular a');
        renderSuggestions(queryLinks);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error('Main search predictive fetch error:', error);
          hideSuggestions();
        }
      });
  }

  function onInput() {
    const query = searchInput.value.trim();

    if (!query.length) {
      hideSuggestions();
      return;
    }

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => fetchPredictiveResults(query), 250);
  }

  searchInput.addEventListener('input', onInput);
  searchInput.addEventListener('blur', function () {
    setTimeout(hideSuggestions, 150);
  });
});
